import '../ProjectsList/ProjectCard/projectCard.scss';
import './subMenu.scss';
import { Button, ModalNooco } from '@photocarbone/nooco-ui';
import { CompanyDTO } from '../../../models/ProjectDTO';
import { PathDTO } from '../../../models/ProjectsDTO';
import { TextField } from '@material-ui/core';
import { divide } from 'lodash';
import { useDeleteFolder } from '../../../../hooks/useQuery/folders/deleteFolder';
import { useDrop } from 'react-dnd';
import { useUpdateFolder } from '../../../../hooks/useQuery/folders/patchFolder';
import { useUpdateProject } from '../../../../hooks/useQuery/projects/patchProject';
import React, { useEffect, useRef, useState } from 'react';
// import Tooltip from '@material-ui/core/Tooltip';
import { StateDTO } from '../../../models/GeneralDTO';
import { Tooltip } from '@mui/material';
import { useClickAway } from 'react-use';
import { usePatchBundle } from '../../../../hooks/useQuery/bundle';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import Loader from '@material-ui/core/CircularProgress';
import useCase from '../useCase/useCase';
import { useTranslation } from 'react-i18next';

type subMenuElementProps = {
  children: JSX.Element | string;
  company?: CompanyDTO;
  path?: PathDTO;
  emptyPath?: number;
};

export const SubMenuElement = ({
  children,
  company,
  path,
  emptyPath,
}: subMenuElementProps) => {
  const { selectedCompanyId } = useSelector(
    (state: StateDTO) => state.projects.projectsListMonitoring.arianeCompany
  );
  const { companyId, folderSheetId, isBundleScreen } = useSelector(
    (state: StateDTO) => state.bundle
  );

  const ParamSvg = (path) => {
    return (
      <div
        style={{ marginLeft: '8px' }}
        className="svgWrapper"
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          handleClickEditButton();
        }}
      >
        <svg
          className="toGrow"
          width="16"
          height="16"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_477_4177)">
            <path
              d="M15.9771 10.1592L15.9811 10.1612C16.0434 9.78147 16.0735 9.39375 16.0735 9.01005C16.0735 8.66652 16.0474 8.32098 15.9992 7.98348C16.0474 8.31897 16.0715 8.65848 16.0715 8.99799C16.0715 9.38772 16.0393 9.77746 15.9771 10.1592ZM0.703174 6.71183C0.693129 6.7038 0.685093 6.69576 0.675049 6.68571C0.689111 6.69978 0.703174 6.71384 0.719245 6.7279L2.03509 7.85089V7.84888L0.703174 6.71183ZM11.4831 2.37254H11.4851L11.1737 0.689063C11.1697 0.668973 11.1657 0.650893 11.1596 0.632812C11.1617 0.642857 11.1657 0.654911 11.1677 0.664955L11.4831 2.37254ZM12.5679 13.3513L13.1987 12.833L15.063 13.494C15.4045 13.0339 15.6918 12.5397 15.9188 12.0154L14.4181 10.7317L14.5507 9.92612C14.6009 9.62277 14.6271 9.31138 14.6271 9C14.6271 8.68862 14.6009 8.37723 14.5507 8.07388L14.4201 7.27232L15.9208 5.98862C15.6918 5.4663 15.4065 4.97009 15.065 4.51005L13.2007 5.17098L12.5699 4.65268C12.0898 4.25893 11.5534 3.94955 10.9768 3.73259L10.2114 3.44531L9.85184 1.49665C9.28445 1.43237 8.71163 1.43237 8.14425 1.49665L7.78465 3.44933L7.02326 3.73661C6.45072 3.95357 5.91835 4.26295 5.44224 4.65469L4.81143 5.175L2.93509 4.50804C2.59358 4.96808 2.3063 5.46228 2.07929 5.98661L3.59603 7.28237L3.46545 8.08594C3.41523 8.38527 3.39112 8.69263 3.39112 9C3.39112 9.30536 3.41724 9.61473 3.46545 9.91406L3.59603 10.7176L2.07929 12.0134C2.30831 12.5357 2.59358 13.0319 2.93509 13.492L4.81143 12.825L5.44224 13.3453C5.91835 13.7371 6.45072 14.0464 7.02326 14.2634L7.78264 14.5547L8.14224 16.5074C8.70875 16.5717 9.28532 16.5717 9.84983 16.5074L10.2094 14.5587L10.9748 14.2714C11.5534 14.0545 12.0878 13.7451 12.5679 13.3513ZM9.01009 12.3408C8.39737 12.3408 7.82081 12.1842 7.31657 11.9089C6.21367 11.3103 5.46433 10.1431 5.46433 8.79911C5.46433 6.84643 7.04737 5.26339 9.00005 5.26339C10.344 5.26339 11.5112 6.01272 12.1099 7.11563C12.3851 7.61786 12.5418 8.19442 12.5418 8.80915C12.5418 10.7598 10.9608 12.3408 9.01009 12.3408ZM2.87683 15.0429C2.76634 15.081 2.65183 15.0891 2.54335 15.067C2.65786 15.0911 2.7784 15.0871 2.89492 15.0469L4.53018 14.4643C4.52817 14.4623 4.52416 14.4603 4.52215 14.4583L2.87683 15.0429ZM17.2929 6.71183L15.9771 7.83683C15.9771 7.84085 15.9791 7.84688 15.9791 7.85089L17.2929 6.7279C17.4355 6.60536 17.5159 6.42857 17.5179 6.24576C17.5119 6.42254 17.4315 6.5933 17.2929 6.71183Z"
              fill="#FAFAFA"
            />
            <path
              d="M17.5137 11.7041C17.5238 11.7985 17.5137 11.895 17.4796 11.9874L17.4615 12.0396C17.0983 13.0516 16.556 13.99 15.8604 14.8099L15.8242 14.8521C15.7399 14.9517 15.6273 15.0233 15.5014 15.0574C15.3754 15.0915 15.2421 15.0865 15.1191 15.0429L13.4858 14.4624C12.8867 14.956 12.2099 15.347 11.4829 15.6195L11.1675 17.3271C11.1437 17.4556 11.0814 17.5738 10.9888 17.666C10.8962 17.7582 10.7778 17.8201 10.6492 17.8434L10.595 17.8534C10.0699 17.9483 9.53746 17.9961 9.00391 17.9961H9.00993C9.54632 17.9961 10.0827 17.9479 10.605 17.8534L10.6593 17.8434C10.7878 17.8201 10.9063 17.7582 10.9989 17.666C11.0914 17.5738 11.1538 17.4556 11.1776 17.3271L11.493 15.6215C12.2202 15.3483 12.8912 14.9606 13.4939 14.4664L15.1251 15.047C15.2481 15.0905 15.3815 15.0955 15.5074 15.0614C15.6334 15.0273 15.746 14.9557 15.8302 14.8561L15.8664 14.8139C16.5655 13.9883 17.1019 13.0581 17.4655 12.0476L17.4836 11.9954C17.5157 11.901 17.5258 11.8005 17.5137 11.7041Z"
              fill="#FAFAFA"
            />
            <path
              d="M12.5358 8.79914C12.5358 8.19044 12.3811 7.61588 12.1099 7.11566C11.5112 6.01276 10.344 5.26343 9.00007 5.26343C7.04739 5.26343 5.46436 6.84646 5.46436 8.79914C5.46436 10.1431 6.21369 11.3103 7.31659 11.909C7.81681 12.1802 8.38936 12.3349 9.00007 12.3349C10.9527 12.3349 12.5358 10.7518 12.5358 8.79914ZM6.75007 8.79914C6.75007 8.19847 6.98511 7.63396 7.409 7.20807C7.83489 6.78218 8.3994 6.54914 9.00007 6.54914C9.60074 6.54914 10.1652 6.78218 10.5911 7.20807C10.8004 7.41675 10.9664 7.66476 11.0795 7.93782C11.1926 8.21087 11.2505 8.50359 11.2501 8.79914C11.2501 9.39981 11.015 9.96432 10.5911 10.3902C10.3825 10.5995 10.1345 10.7655 9.8614 10.8785C9.58834 10.9916 9.29562 11.0496 9.00007 11.0491C8.3994 11.0491 7.83489 10.8141 7.409 10.3902C7.19971 10.1815 7.03376 9.93353 6.92067 9.66047C6.80759 9.38741 6.74961 9.09469 6.75007 8.79914Z"
              fill="#A3AED0"
            />
            <path
              d="M10.6492 17.8434C10.7778 17.8201 10.8963 17.7582 10.9888 17.666C11.0814 17.5738 11.1437 17.4556 11.1675 17.3271L11.4829 15.6195C12.2099 15.347 12.8867 14.956 13.4858 14.4624L15.1191 15.0429C15.2421 15.0865 15.3755 15.0915 15.5014 15.0574C15.6274 15.0233 15.74 14.9517 15.8242 14.8521L15.8604 14.8099C16.5595 13.9842 17.0979 13.0521 17.4615 12.0396L17.4796 11.9874C17.5137 11.895 17.5238 11.7985 17.5137 11.7041C17.4957 11.5454 17.4193 11.3947 17.2928 11.2842L15.9809 10.1612L15.9769 10.1592C16.0392 9.77754 16.0713 9.38781 16.0713 8.99808C16.0713 8.65857 16.0472 8.31705 15.999 7.98357C15.993 7.93937 15.985 7.89517 15.9789 7.85098C15.9789 7.84696 15.9769 7.84093 15.9769 7.83691L17.2928 6.71191C17.4314 6.59339 17.5117 6.42263 17.5178 6.24584C17.5198 6.16549 17.5077 6.08312 17.4796 6.00477L17.4615 5.95254C17.0993 4.94009 16.5568 4.00154 15.8604 3.18223L15.8242 3.14004C15.7398 3.0407 15.6272 2.96929 15.5013 2.93522C15.3754 2.90116 15.2422 2.90602 15.1191 2.94919L13.4858 3.52977C12.8832 3.03557 12.2122 2.64584 11.485 2.37263H11.4829L11.1675 0.665039C11.1655 0.654994 11.1635 0.642941 11.1595 0.632896C11.1305 0.511436 11.0668 0.401018 10.9762 0.315066C10.8857 0.229115 10.7721 0.171332 10.6492 0.148744L10.595 0.1387C9.54834 -0.0501395 8.44745 -0.0501395 7.4008 0.1387L7.34656 0.148744C7.21798 0.172041 7.09953 0.233909 7.00696 0.326128C6.91438 0.418348 6.85205 0.536552 6.82825 0.665039L6.51084 2.38066C5.78941 2.65394 5.11759 3.04346 4.52201 3.53379L2.87669 2.94919C2.75368 2.90568 2.62033 2.90064 2.49438 2.93473C2.36843 2.96882 2.25584 3.04043 2.17156 3.14004L2.1354 3.18223C1.4398 4.00212 0.897447 4.94052 0.534281 5.95254L0.516201 6.00477C0.474337 6.12153 0.467043 6.24788 0.495193 6.36867C0.523343 6.48947 0.585742 6.59958 0.674906 6.6858C0.684951 6.69383 0.692987 6.70388 0.703031 6.71191L2.03495 7.84897V7.85098C1.97267 8.22866 1.94254 8.61236 1.94254 8.99607C1.94254 9.38178 1.97267 9.7675 2.03495 10.1432L0.703031 11.2802C0.603782 11.3652 0.532747 11.4783 0.499374 11.6047C0.466001 11.731 0.47187 11.8645 0.516201 11.9874L0.534281 12.0396C0.897898 13.0521 1.43629 13.9862 2.1354 14.8099L2.17156 14.8521C2.27 14.9666 2.40058 15.0409 2.54321 15.067C2.65169 15.0871 2.7662 15.0811 2.87669 15.0429L4.52201 14.4583C4.52401 14.4604 4.52803 14.4624 4.53004 14.4644C5.12669 14.9525 5.79165 15.3403 6.51084 15.6115L6.82825 17.3271C6.85205 17.4556 6.91438 17.5738 7.00696 17.666C7.09953 17.7582 7.21798 17.8201 7.34656 17.8434L7.4008 17.8534C7.92513 17.9479 8.46151 17.9961 8.9979 17.9961H9.00393C9.5383 17.9961 10.0747 17.9479 10.595 17.8534L10.6492 17.8434ZM9.84968 16.5075C9.2823 16.5717 8.70948 16.5717 8.14209 16.5075L7.7825 14.5548L7.02312 14.2635C6.45058 14.0465 5.91821 13.7371 5.44209 13.3454L4.81129 12.8251L2.93495 13.492C2.59343 13.032 2.30817 12.5358 2.07915 12.0135L3.59589 10.7177L3.46531 9.91415C3.41709 9.61482 3.39098 9.30544 3.39098 9.00008C3.39098 8.69272 3.41509 8.38535 3.46531 8.08602L3.59589 7.28245L2.07915 5.98669C2.30616 5.46236 2.59343 4.96816 2.93495 4.50812L4.81129 5.17508L5.44209 4.65477C5.91821 4.26303 6.45058 3.95366 7.02312 3.73669L7.7845 3.44941L8.1441 1.49674C8.70861 1.43245 9.28518 1.43245 9.85169 1.49674L10.2113 3.4454L10.9767 3.73267C11.5533 3.94964 12.0896 4.25901 12.5698 4.65276L13.2006 5.17107L15.0649 4.51013C15.4064 4.97017 15.6916 5.46638 15.9207 5.9887L14.42 7.27241L14.5506 8.07397C14.6008 8.37732 14.6269 8.6887 14.6269 9.00008C14.6269 9.31147 14.6008 9.62285 14.5506 9.9262L14.418 10.7318L15.9187 12.0155C15.6912 12.5396 15.404 13.0357 15.0629 13.4941L13.1986 12.8331L12.5678 13.3514C12.0876 13.7452 11.5533 14.0546 10.9747 14.2715L10.2093 14.5588L9.84968 16.5075Z"
              fill="#A3AED0"
            />
          </g>
          <defs>
            <clipPath id="clip0_477_4177">
              <rect width="18" height="18" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
    );
  };

  const DeleteSvg = () => {
    return (
      <div
        style={{ marginLeft: '0px' }}
        className="svgWrapper"
        onClick={(event) => {
          event.stopPropagation();
          event.preventDefault();
          handleClickDeleteButton(event);
        }}
      >
        <svg
          className="toGrow"
          width="16"
          height="16"
          viewBox="0 0 30 31"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M27.9408 5.46668H23.0815V2.42963C23.0815 1.08954 21.992 0 20.6519 0H8.50372C7.16362 0 6.07408 1.08954 6.07408 2.42963V5.46668H1.21482C0.542871 5.46668 0 6.00955 0 6.68149V7.89631C0 8.06335 0.136667 8.20001 0.303704 8.20001H2.59667L3.53436 28.0547C3.5951 29.3492 4.66566 30.3704 5.96019 30.3704H23.1954C24.4937 30.3704 25.5605 29.353 25.6212 28.0547L26.5589 8.20001H28.8519C29.0189 8.20001 29.1556 8.06335 29.1556 7.89631V6.68149C29.1556 6.00955 28.6127 5.46668 27.9408 5.46668ZM8.80742 2.73334H20.3482V5.46668H8.80742V2.73334ZM22.9031 27.6371H6.25251L5.3338 8.20001H23.8218L22.9031 27.6371Z"
            fill="#A3AED0"
          />
        </svg>
      </div>
    );
  };
  const [editInputFolder, setEditInputFolder] = useState('');
  const { t } = useTranslation();
  const [isEditFolder, setIsEditFolder] = useState(false);
  const updateFolder = useUpdateFolder();
  const deletePath = useDeleteFolder();
  const { isLoading: isLoadingDelete } = deletePath;
  const ref = useRef(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openDragErrorModal, setOpenDragErrorModal] = useState(false);
  const queryClient = useQueryClient();
  const folders: PathDTO[] | undefined = isBundleScreen
    ? queryClient.getQueryData(['foldersByCompany', [companyId, isBundleScreen]])
    : queryClient.getQueryData([
        'foldersByCompany',
        [selectedCompanyId, isBundleScreen],
      ]);
  const updateBundle = usePatchBundle();

  const handleEditFolder = () => {
    // console.log('path in edit folder"',
    //   path);
    updateFolder.mutate({
      id: path?.id,
      body: {
        name: editInputFolder,
      },
    });
    // dispatch(updateProjectsListMonitoring('isEditFolder',
    //   false));
    setIsEditFolder(false);

    setEditInputFolder('');
  };
  const handleClickEditButton = () => {
    // console.log('click',
    //   path);
    // console.log(path?.name);
    setEditInputFolder(path?.name || '');
    setIsEditFolder(true);
    // dispatch(updateProjectsListMonitoring('isEditFolder',
    //   true));
  };

  const handleClickDeleteButton = (e) => {
    handleOpenDeleteModal(e);
  };
  const { selectCompanyOnSubmenu, selectPathOnSubmenu } = useCase();
  const { mutate, isLoading } = useUpdateProject();

  const calculateObjectInFolder = (folderId) => {
    let currentFolder = folders?.find((folder) => folder.id === folderId);

    let totalProjects = currentFolder?.objectCount || 0;

    let subFolders = folders?.filter((folder) => folder.parentId === folderId);

    subFolders?.forEach((subFolder) => {
      totalProjects += calculateObjectInFolder(subFolder.id);
    });

    return totalProjects;
  };

  const [{ isOver, canDrop }, drop] = useDrop(() => ({
    accept: 'projectCard',
    canDrop: () => true,
    drop: (item) => {
      // folderSheetId is the folderId of the bundle
      const pathIdOrigin = item?.project?.FolderId || folderSheetId || null;
      const pathIdTarget = emptyPath || path?.id || null;
      //! company is not null when it's a company Element. So when company it's undefined it's a folder element.
      const isFolderItem = !company;
      // We don't autorise to drop a folder in another company
      const isSameCompanyFolder =
        item?.project?.Company?.id === selectedCompanyId ||
        item?.project?.CompanyId === selectedCompanyId;
      const isSameFolderTargetAndOrigin = pathIdOrigin === pathIdTarget;

      if (isSameFolderTargetAndOrigin) {
        return;
      }

      if (isBundleScreen) {
        if (companyId && path) {
          updateBundle.mutate({
            id: item.line.id,
            CompanyId: companyId,
            folderSheetId: path.id,
            moveFolder: true,
          });
        } else {
          updateBundle.mutate({
            id: item.line.id,
            CompanyId: companyId,
            folderSheetId: null,
          });
        }
      } else {
        if (isFolderItem && isSameCompanyFolder) {
          mutate({
            projectId: item.project.id,
            body: { FolderId: pathIdTarget },
          });
        } else if (
          // to move a project from searchBar into a company Element: only if it's the same company and into the root folder
          item?.project?.Company?.id === company?.id
        ) {
          mutate({ projectId: item.project.id, body: { FolderId: null } });
        } else {
          setOpenDragErrorModal(true);
        }
      }
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: !!monitor.canDrop(),
    }),
  }));

  const handleOpenDeleteModal = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setOpenDeleteModal(true);
  };

  const handleCloseModal = () => {
    setOpenDeleteModal(false);
  };

  const handleCloseDragModal = () => {
    setOpenDragErrorModal(false);
  };

  useClickAway(ref, (e) => {
    // console.log('clickaway');

    handleCancelEditFolder(e);
  });

  const handleCancelEditFolder = (e) => {
    console.log('clickaway');
    e.stopPropagation();
    e.preventDefault();

    setEditInputFolder('');
    setIsEditFolder(false);
  };

  const handleDeleteProject = () => {
    deletePath.mutate(path?.id);
    handleCloseModal();
    setIsEditFolder(false);
  };

  return (
    <>
      <ModalNooco
        title="Suppression du dossier"
        isOpen={openDeleteModal}
        cancelFunction={handleCloseModal}
        validateFunction={handleDeleteProject}
        closeOnOutsideClick={false}
        closeIcon={true}
      >
        {/* //TODO  condition isBundle is temp because we can't have calculateObjectInFolder for the moment */}
        {isBundleScreen && (
          <div>
            <span>
              {t('APP.SUBMENU.SUBMENUELEMENT.PH_46D9C7', {
                defaultValue: 'Vous êtes sur le point de',
              })}{' '}
              <span style={{ color: '#dc3545' }}>
                {t('APP.SUBMENU.SUBMENUELEMENT.PH_0E4A72', {
                  defaultValue: 'supprimer le dossier',
                })}
                <span
                  style={{
                    fontStyle: 'italic',
                    fontWeight: '700',
                    fontSize: '22px',
                  }}
                >
                  {` ${path?.name}.`}
                </span>
              </span>{' '}
              {t('APP.SUBMENU.SUBMENUELEMENT.PH_902481', {
                defaultValue:
                  'Tous les ensembles contenus dans ce dossier seront supprimés. Voulez-vous continuer ?',
              })}
            </span>
          </div>
        )}
        {!isBundleScreen && (
          <div>
            <span>
              {t('APP.SUBMENU.SUBMENUELEMENT.PH_3EF79B', {
                defaultValue: 'Vous êtes sur le point de',
              })}{' '}
              <span style={{ color: '#dc3545' }}>
                {t('APP.SUBMENU.SUBMENUELEMENT.PH_233698', {
                  defaultValue: 'supprimer le dossier',
                })}
                <span
                  style={{
                    fontStyle: 'italic',
                    fontWeight: '700',
                    fontSize: '22px',
                  }}
                >
                  {` ${path?.name}.`}
                </span>
              </span>{' '}
              {t('APP.SUBMENU.SUBMENUELEMENT.PH_11C18D', {
                defaultValue: 'Ce dossier contient',
              })}
              <span style={{ color: '#dc3545' }}>{` ${calculateObjectInFolder(
                path?.id
              )} ${isBundleScreen ? 'ensemble' : 'projet'}${
                calculateObjectInFolder(path?.id) === 1 ||
                calculateObjectInFolder(path?.id) === 0
                  ? ''
                  : 's'
              }`}</span>
              {'. '}
              {calculateObjectInFolder(path?.id) === 0
                ? ''
                : calculateObjectInFolder(path?.id) === 1
                ? `${isBundleScreen ? 'Cet ensemble' : 'Ce projet'} sera supprimé. `
                : ` ${
                    isBundleScreen ? 'Ces ensembles' : 'Ces projets'
                  } seront supprimés. `}
              Voulez-vous continuer ?
            </span>
          </div>
        )}
      </ModalNooco>
      <ModalNooco
        title="Déplacement projet"
        isOpen={openDragErrorModal}
        cancelFunction={handleCloseDragModal}
        validateFunction={handleCloseDragModal}
        closeOnOutsideClick={false}
        closeIcon={true}
      >
        <div>
          {t('APP.SUBMENU.SUBMENUELEMENT.PH_E47C43', {
            defaultValue:
              "Il n'est pas possible de déplacer un projet dans une autre entreprise pour le moment",
          })}
        </div>
      </ModalNooco>
      <div
        ref={drop}
        className={
          children.props.children !==
          t('APP.SUBMENU.SUBMENU.PH_3B5907', { defaultValue: 'Aucun dossier' })
            ? 'subMenuElement'
            : 'subMenuElementNotAccessible'
        }
        style={{
          backgroundColor:
            canDrop && !isOver ? '#44DDC350' : isOver ? '#44DDC380' : '',
        }}
        onClick={() => {
          if (company?.id && !isEditFolder) {
            selectCompanyOnSubmenu(company);
          }
          if (path?.id && !isEditFolder) {
            selectPathOnSubmenu(path);
          }
        }}
      >
        {children}
        {!isEditFolder && path && <div>{path?.name}</div>}
        {isEditFolder && path && (
          <div
            ref={ref}
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
            }}
            // onBlur={(e) =>{ e.preventDefault(); e.stopPropagation();  handleCancelEditFolder(); }}
          >
            <TextField
              autoFocus
              id="standard-basic"
              value={editInputFolder}
              onChange={(e) => {
                setEditInputFolder(e.currentTarget.value);
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleEditFolder();
                }
              }}
            />

            <Tooltip
              title={t('APP.SUBMENU.SUBMENUELEMENT.PH_E77AB9', {
                defaultValue: 'Supprimer le dossier',
              })}
            >
              <div>
                <DeleteSvg />
              </div>
            </Tooltip>
          </div>
        )}

        {path && !isEditFolder && (
          <>
            <Tooltip
              title={t('APP.SUBMENU.SUBMENUELEMENT.PH_4B67C8', {
                defaultValue: 'Modifier ou supprimer le dossier',
              })}
            >
              {/* <> */}
              <div>
                <ParamSvg path={path} />
              </div>
              {/* </> */}
            </Tooltip>
          </>
        )}
        {/* TODO TEST IS LOADING DURING MUTATE */}
        {isLoadingDelete && (
          <div>
            <Loader
              variant="indeterminate"
              disableShrink
              style={{ color: '#73b7ec' }}
              size={12}
              thickness={4}
            />
          </div>
        )}
      </div>
    </>
  );
};
